module.exports = new __parcel__URL__("android-chrome-192x192.80eb3d4c.png").toString();